"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KYBStepsEnum = void 0;
var KYBStepsEnum;
(function (KYBStepsEnum) {
    KYBStepsEnum[KYBStepsEnum["COMPANY_DETAILS"] = 0] = "COMPANY_DETAILS";
    KYBStepsEnum[KYBStepsEnum["CREATE_PASSWORD"] = 1] = "CREATE_PASSWORD";
    KYBStepsEnum[KYBStepsEnum["VERIFY_EMAIL"] = 2] = "VERIFY_EMAIL";
    KYBStepsEnum[KYBStepsEnum["VERIFY_MOBILE"] = 3] = "VERIFY_MOBILE";
    KYBStepsEnum[KYBStepsEnum["KYB_FORM"] = 4] = "KYB_FORM";
    KYBStepsEnum[KYBStepsEnum["CREATE_ACCOUNT"] = 5] = "CREATE_ACCOUNT";
})(KYBStepsEnum || (exports.KYBStepsEnum = KYBStepsEnum = {}));
